export default __webpack_public_path__ + "static/media/honey_family_image.45f2a968.png";